import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 768px)', width: '40vw' }]

export default function LianaTablet({
  image,
  imageAlt,
  height = 1346,
}: {
  image: string
  imageAlt?: string
  height?: number
}): React.ReactElement {
  return (
    <ResponsiveImage
      alt={imageAlt}
      height={height}
      imageClassName="absolute z-0 -top-24 left-0 max-w-none w-[700px]"
      loading="eager"
      mediaQuery={mediaQuery}
      srcKey={image}
      width={700}
    />
  )
}
